import React from "react";
import { cn } from "@/lib/utils";

interface ContentProcessingToastProps {
  title: string;
  phrase: string;
  progress: number;
  done?: boolean;
}

export const ContentProcessingToast: React.FC<ContentProcessingToastProps> = ({
  title,
  phrase,
  progress,
  done = false,
}) => {
  const pct = Math.max(0, Math.min(100, Math.round(progress)));

  return (
    <div
      className={cn(
        "w-[340px] max-w-[calc(100vw-2rem)] rounded-xl border bg-background text-foreground shadow-lg p-3"
      )}
    >
      <div className="text-sm font-medium">{title}</div>
      <div className="mt-1 flex items-center justify-between gap-3">
        <span
          key={phrase}
          className="text-sm text-muted-foreground truncate animate-in fade-in duration-300"
        >
          {phrase}
        </span>
        <span
          className={cn(
            "text-sm font-medium tabular-nums",
            done ? "text-emerald-600" : "text-emerald-600"
          )}
        >
          {pct}%
        </span>
      </div>
      <div className="mt-2 h-1 w-full overflow-hidden rounded-full bg-muted">
        <div
          className="h-full rounded-full bg-emerald-500 transition-all duration-500 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
};
